import React from 'react';
import { Button } from '@/components/ui/button';
import Header1 from '@/imgs/AssetAllocation/header1.png';
import { useSend } from '../../hooks/useSend';
import { Loader2 } from 'lucide-react';
interface HeaderSectionProps {
  showSendButton?: boolean;
  showExportButton?: boolean;
  btnDisabled?: boolean;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  showSendButton = true,
  showExportButton = false,
  btnDisabled = false
}) => {
  const { sending, sendData } = useSend();

  const handleSend = () => {
    sendData();
  };

  return (
    <div className="mb-3 mt-6 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded">
          <img src={Header1} alt="header1" className="h-5 w-5" />
        </div>
        <span className="text-base font-semibold text-black">战略资产配置方案</span>
      </div>
      <div className="flex items-center gap-2">
        {showSendButton && (
          <Button
            className="h-8 rounded bg-gradient-to-r from-[#5D2BC7] to-[#A644CA] px-2 py-1 text-sm text-white shadow-sm disabled:opacity-50"
            onClick={handleSend}
            disabled={btnDisabled}
          >
            {sending && <Loader2 className="h-4 w-4 animate-spin" />}
            <span>{sending ? '发送中...' : '发送'}</span>
          </Button>
        )}
        {showExportButton && (
          <Button className="flex items-center gap-1 rounded border border-[#5959EB] bg-white px-2 py-1 text-sm text-[#5959EB]">
            <span>导出</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default HeaderSection;
